import * as firebase from 'firebase';


const config = {
  apiKey: "AIzaSyAtjJAtoEMIFN-t7x5KduN3EPSk4ZTa-3g",
  authDomain: "haniumnoisecheckapp.firebaseapp.com",
  databaseURL: "https://haniumnoisecheckapp.firebaseio.com",
  projectId: "haniumnoisecheckapp",
  storageBucket: "haniumnoisecheckapp.appspot.com",
  messagingSenderId: "520115262523",
  appId: "1:520115262523:web:e2fa2c0e9fc422eb"
};

firebase.initializeApp(config);
export default firebase;



// WEBPACK FOOTER //
// ./src/Firebase.js